import { render, staticRenderFns } from "./index-nav.vue?vue&type=template&id=59891ec8&scoped=true"
import script from "./index-nav.vue?vue&type=script&lang=js"
export * from "./index-nav.vue?vue&type=script&lang=js"
import style0 from "./index-nav.vue?vue&type=style&index=0&id=59891ec8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59891ec8",
  null
  
)

export default component.exports